/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*                                 */
export const SCSS_MODULES: Record<string, () => Promise<string>> =
  import.meta.glob(['../scss/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function importStyles(stylesScss: string): Promise<string> {
  return SCSS_MODULES[`../scss/${stylesScss}`]()
}
